import keyMirror from 'keymirror';

export const publicProfileActionTypes = keyMirror({
	GET_PUBLIC_PROFILE_INFO_REQUEST: null,
	GET_PUBLIC_PROFILE_INFO_SUCCESS: null,
	GET_PUBLIC_PROFILE_INFO_ERROR: null,

	GET_PUBLIC_LISTS_REQUEST: null,
	GET_PUBLIC_LISTS_SUCCESS: null,
	GET_PUBLIC_LISTS_ERROR: null,

	GET_PUBLIC_FOLDERS_REQUEST: null,
	GET_PUBLIC_FOLDERS_SUCCESS: null,
	GET_PUBLIC_FOLDERS_ERROR: null,

	CHECK_USER_NAME_REQUEST: null,
	CHECK_USER_NAME_SUCCESS: null,
	CHECK_USER_NAME_ERROR: null,

	GET_PUBLIC_QUESTIONS_REQUEST: null,
	GET_PUBLIC_QUESTIONS_SUCCESS: null,
	GET_PUBLIC_QUESTIONS_ERROR: null,
	GET_PUBLIC_ANSWERS_REQUEST: null,
	GET_PUBLIC_ANSWERS_SUCCESS: null,
	GET_PUBLIC_ANSWERS_ERROR: null,

	GET_ACHIEVEMENTS_REQUEST: null,
	GET_ACHIEVEMENTS_SUCCESS: null,
	GET_ACHIEVEMENTS_ERROR: null,

	SET_LOADING: null,
	CLEAR_PUBLIC_PROFILE_INFO: null,
	CLEAR_PUBLIC_LISTS: null,
	CLEAR_PUBLIC_FOLDERS: null,
});

export const getMenuItems = (t) => [
	{ title: t('public_profile.tabs.created'), value: 'created', index: 0, link: 'created' },
	{ title: t('public_profile.tabs.folders'), value: 'folders', index: 1, link: 'folders' },
	{
		title: t('public_profile.tabs.questions'),
		value: 'questions',
		index: 2,
		link: 'questions',
	},
	{ title: t('public_profile.tabs.answers'), value: 'answers', index: 3, link: 'answers' },
];

export const getSortingOptions = (t) => [
	{
		title: t('public_profile.sorting_options.last_updated'),
		key: 'last_updated_at_timestamp',
	},
	{
		title: t('public_profile.sorting_options.last_practiced'),
		key: 'last_practiced_timestamp',
	},
	{ title: t('public_profile.sorting_options.alphabetical'), key: 'alphabetical' },
	{ title: t('public_profile.sorting_options.language'), key: 'language' },
];

export const getSortingOptionsFolder = (t) => [
	{ title: t('public_profile.sorting_options.created_at'), key: 'created_at_timestamp' },
	{ title: t('public_profile.sorting_options.alphabetical'), key: 'alphabetical' },
];
